import React, { useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

export default function FilteredSelect({
  destinataires,
  selectedDestByGroups,
  destinataireValue,
  setDestinataireValue,
}) {
  // const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (selectedDestByGroups?.results) {
      const filteredDestinataires =
        selectedDestByGroups.results.length > 0
          ? destinataires.results.filter((destinataire) =>
              selectedDestByGroups.results.some(
                (destByGroup) =>
                  parseInt(destByGroup.id) === parseInt(destinataire.id)
              )
            )
          : [];
      setDestinataireValue(filteredDestinataires);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDestByGroups, destinataires]);

  return (
    <Autocomplete
      multiple
      options={destinataires.results || []}
      getOptionLabel={(option) => option.text || ""}
      value={destinataireValue || []}
      onChange={(event, newValue) => setDestinataireValue(newValue)}
      style={{ paddingTop: 5, overflow: "auto", maxHeight: 210 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Destinataires"
          variant="outlined"
          /* onChange={(e) => setSearchQuery(e.target.value)} */
        />
      )}
      filterOptions={(options, state) =>
        options.filter((option) =>
          option.text.toLowerCase().includes(state.inputValue.toLowerCase())
        )
      }
    />
  );
}
